export default "__VITE_ASSET__14794b14__"